/**
 * @author Srijan Shakya
 * @description https://marvelapp.com/4g4b5dg/screen/61020234
 */

import React from 'react';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import clone from 'ramda/src/clone';
import values from 'ramda/src/values';
import Pagination from '@components/@core/Pagination';

const moment = extendMoment(originalMoment);

const dateArray = (start, end) => {
    let months = [];
    while (start.isBefore(end)) {
        months.push({ name: start.format('MMM'), value: start.format('YYYY-MMM') });
        start.add(1, 'month');
    }
    return months;
};

class Report extends React.PureComponent {
    state = { current: 1, per: 10 };

    handlePagination = (e) => {
        this.props.onPage(e, this.state.per);
        this.setState({ current: e });
    };

    handlePer = (e) => {
        this.props.onPage(this.state.current, e);
        this.setState({ per: e });
    };

    render() {
        const { data, dateStart, dateEnd } = this.props;
        const { employee_name, last_page } = data;
        const _dateStart = moment(dateStart);
        const _dateEnd = moment(dateEnd);
        const months = dateArray(_dateStart, _dateEnd);

        return (
            <div className="individaul-quota-reports">
                <p className="dsl-b18 bold my-4">{employee_name}</p>
                <div className="report-item">
                    <div className="d-flex-5 text-start text-400 mb-2">
                        <p className="dsl-m12 text-400">Scorecard Quotas</p>
                    </div>
                    {months.map((month, index) => (
                        <div className="d-flex-1 text-end" key={`header-${index}`}>
                            <p className="dsl-m12 text-400">{month.name}</p>
                        </div>
                    ))}
                    <div className="d-flex-1 mb-2" />
                </div>
                {values(data.data).map((item, index) => {
                    const { name, data, actuals, created_at } = item;
                    const _actuals = actuals.map((item) => {
                        const _item = clone(item);
                        _item.actual_at = moment(item.actual_at).format('YYYY-MMM');
                        return _item;
                    });
                    return (
                        <div className="report-item py-4" key={`quota-${index}`}>
                            <div className="d-flex-5 text-start text-400 mb-2">
                                <p className="dsl-b14 mb-0 text-400">{name}</p>
                            </div>
                            {months.map((month, index) => {
                                const actual = find(propEq('actual_at', month.value), _actuals);
                                return (
                                    <div className="d-flex-1 text-end" key={`list-${index}`}>
                                        <p className="dsl-b14 mb-0 text-400">{actual?.actual || 'NA'}</p>
                                    </div>
                                );
                            })}
                            <div className="d-flex-1 mb-2" />
                        </div>
                    );
                })}
                <Pagination current={this.state.current} total={last_page} onChange={this.handlePagination} onPer={this.handlePer} />
            </div>
        );
    }
}

export default Report;
